import { createContext, useContext, useEffect, useState } from "react";
import { endpoints } from "@/lib/api";

const SettingsContext = createContext({ settings: null, loading: true });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    endpoints
      .settings()
      .then((data) => {
        if (mounted) setSettings(data);
      })
      .catch((e) => console.error("settings load failed", e))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

// Build a WhatsApp URL with prefilled Arabic message
export function buildWhatsAppUrl(number, message) {
  if (!number) return "#";
  const clean = String(number).replace(/[^\d]/g, "");
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${clean}${text ? `?text=${text}` : ""}`;
}
